/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentGameInfo
 */
export interface TournamentGameInfo {
    /**
     * 
     * @type {string}
     * @memberof TournamentGameInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentGameInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentGameInfo
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentGameInfo
     */
    backgroundUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentGameInfo
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentGameInfo
     */
    iconUrl?: string;
}

/**
 * Check if a given object implements the TournamentGameInfo interface.
 */
export function instanceOfTournamentGameInfo(value: object): value is TournamentGameInfo {
    return true;
}

export function TournamentGameInfoFromJSON(json: any): TournamentGameInfo {
    return TournamentGameInfoFromJSONTyped(json, false);
}

export function TournamentGameInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentGameInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'backgroundUrl': json['backgroundUrl'] == null ? undefined : json['backgroundUrl'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
    };
}

export function TournamentGameInfoToJSON(json: any): TournamentGameInfo {
    return TournamentGameInfoToJSONTyped(json, false);
}

export function TournamentGameInfoToJSONTyped(value?: TournamentGameInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'backgroundUrl': value['backgroundUrl'],
        'logoUrl': value['logoUrl'],
        'iconUrl': value['iconUrl'],
    };
}

